let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7ctJN")).then(() => parcelRequire('eb0cf'));